interface SellerHistoricData {
  seller_id: number;
  seller: string;
  total_vendido: string;
}

interface HistoricResponse {
  start_date: string;
  end_date: string;
  sellers: SellerHistoricData[];
  total_geral: string;
}

/**
 * Gera dados para exportação no formato CSV específico para histórico de vendedores
 * 
 * @param data - Dados do histórico de vendedores
 * @returns Array de arrays contendo os dados formatados para CSV
 */
export const generateSellersHistoricCSVData = (data: HistoricResponse): string[][] => {

  const headers = [
    'Nome do Vendedor',
    'Total de Vendas'
  ];
  
  const rows = data.sellers.map(seller => [
    seller.seller,
    `R$ ${seller.total_vendido}`
  ]);
  
  const separatorRow = ['', ''];
  const totalsRow = [
    'TOTAL GERAL',
    `R$ ${data.total_geral}`
  ];
  
  const periodInfo: string[][] = [
    ['', ''],
    [`Período: ${formatDate(data.start_date)} a ${formatDate(data.end_date)}`, ''],
    ['', '']
  ];
  
  return [
    ...periodInfo,
    headers,
    ...rows,
    separatorRow,
    totalsRow
  ];
};

/**
 * Formata uma data para exibição brasileira
 */
const formatDate = (dateString: string): string => {
  if (!dateString) return "";
  const [year, month, day] = dateString.split("-");
  if (year && month && day) {
    return `${day.padStart(2, "0")}/${month.padStart(2, "0")}/${year}`;
  }
  return dateString;
};

/**
 * Exporta os dados do histórico de vendedores para download como um arquivo CSV
 * 
 * @param data - Dados do histórico de vendedores
 * @param filename - Nome do arquivo a ser baixado (opcional)
 */
export const exportSellersHistoricToCSV = (
  data: HistoricResponse, 
  filename: string = 'Vendas'
): void => {
  const csvData = generateSellersHistoricCSVData(data);
  const csvContent = csvData.map(row => row.join(';')).join('\n');
  
  const BOM = '\uFEFF';
  const csvWithBOM = BOM + csvContent;
  
  const blob = new Blob([csvWithBOM], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  
  const link = document.createElement('a');
  link.setAttribute('href', url);
  link.setAttribute('download', `${filename}.csv`);
  link.style.visibility = 'hidden';
  
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  
  URL.revokeObjectURL(url);
};

/**
 * Gera nome do arquivo baseado no período dos dados
 */
export const generateSellersHistoricFilename = (data: HistoricResponse): string => {
  const startDate = formatDate(data.start_date).replace(/\//g, '-');
  const endDate = formatDate(data.end_date).replace(/\//g, '-');
  
  return `Vendas_${startDate}_${endDate}`;
};